document.addEventListener('DOMContentLoaded', function() {
  // ================================================================
  // 1. Namespace Global (si ya existe, omite esta parte)
  // ================================================================
  window.EcomverX = window.EcomverX || {
    modules: {},
    registerModule: function(name, initFunction) {
      this.modules[name] = initFunction;
    },
    initModules: function(context) {
      context = context || document;
      for (var key in this.modules) {
        if (this.modules.hasOwnProperty(key)) {
          this.modules[key](context);
        }
      }
    },
    initDesignMode: function() {
      if (typeof Shopify !== 'undefined' && Shopify.designMode) {
        document.addEventListener('shopify:section:load', function(e) {
          // Al cargar una sección, inicializa módulos solo en ese contenedor.
          EcomverX.initModules(e.target);
        });
        document.addEventListener('shopify:section:unload', function(e) {
          // Limpieza o reinicialización si fuera necesario
        });
        document.addEventListener('shopify:block:select', function(e) {
          // Al seleccionar un bloque, inicializamos módulos en ese bloque
          var block = e.target.closest('.ex-block');
          if (block) {
            EcomverX.initModules(block);
          }
        });
        document.addEventListener('shopify:block:deselect', function(e) {
          // Al deseleccionar, podemos reinicializar todo si queremos
          EcomverX.initModules(document);
        });
      }
    }
  };

  

  // ================================================================
  // 2. Variables Globales y Traducciones Inyectadas desde Liquid
  // ================================================================
  // Estas variables se usan para pasar cadenas traducidas a los módulos.

  // ================================================================
  // 3. Registro de Módulos (Funcionalidades de Bloques)
  // ================================================================
  // Módulo para el bloque ex_b001 (Promoción con Contador)
  EcomverX.registerModule('ex_b001', function(context) {
    // Busca todos los elementos del bloque ex_b001 en el contexto proporcionado.
    var blocks = context.querySelectorAll('.ex-b001-wrapper');
    blocks.forEach(function(block) {
      // Evitamos re-inicializar un bloque ya procesado.
      if (!block.getAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');
        var timer = parseInt(block.getAttribute('data-ex-b001-countdown'), 10);
        var display = block.querySelector('.ex-b001-timer');
        if (!display || timer <= 0) return;
        // Limpiamos intervalos previos, si existieran.
        if (block.countdownInterval) {
          clearInterval(block.countdownInterval);
        }
        // Inicia el contador.
        block.countdownInterval = setInterval(function() {
          var minutes = Math.floor(timer / 60);
          var seconds = timer % 60;
          display.textContent = minutes + ":" + (seconds < 10 ? "0" + seconds : seconds);
          if (--timer < 0) {
            clearInterval(block.countdownInterval);
            block.style.display = 'none'; // Oculta el bloque al finalizar el tiempo.
          }
        }, 1000);
      }
    });
  });

  // ================================================================
  // Registro del Módulo para ex_b002 (Trustpilot Rating)
  // ================================================================
  EcomverX.registerModule('ex_b002', function(context) {
    // Selecciona todos los contenedores de ex_b002 en el contexto
    var blocks = context.querySelectorAll('.ex-b002-wrapper');
    blocks.forEach(function(block) {
      // Evita re-inicializar el mismo bloque
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');

        // Función para generar el rating
        function ex_b002_generateRating(block) {
          var mode = block.getAttribute('data-ex-b002-mode');
          var manualDecimal = parseInt(block.getAttribute('data-ex-b002-manual-decimal'), 10);
          var rating = 4.5; // Valor por defecto
          if (mode === 'random') {
            rating = (Math.random() * (4.8 - 4.3) + 4.3).toFixed(1);
          } else if (mode === 'manual' && manualDecimal >= 1 && manualDecimal <= 9) {
            rating = '4.' + manualDecimal;
          }
          var ratingEl = block.querySelector('#ex-b002_rating');
          if (ratingEl) {
            ratingEl.textContent = rating + '/5';
          }
        }

        // Función para asignar frase aleatoria
        function ex_b002_setRandomPhrase(block) {
          var phrasesAttr = block.getAttribute('data-ex-b002-phrases');
          if (!phrasesAttr) return;
          var phrases = phrasesAttr.split(',');
          var randomPhrase = phrases[Math.floor(Math.random() * phrases.length)].trim();
          var phraseEl = block.querySelector('#ex-b002_text');
          if (phraseEl) {
            phraseEl.textContent = '"' + randomPhrase + '"';
          }
        }

        // Inicializa el bloque (genera rating y frase)
        function ex_b002_initialize(block) {
          ex_b002_generateRating(block);
          ex_b002_setRandomPhrase(block);
        }

        // Llamamos a la inicialización una sola vez
        ex_b002_initialize(block);
      }
    });
  });

  // Registro del módulo para el bloque ex_b003 (Píldoras de Beneficios)
  EcomverX.registerModule('ex_b003', function(context) {
    // Selecciona todos los contenedores del bloque en el contexto
    var blocks = context.querySelectorAll('.ex-b003-wrapper');
    blocks.forEach(function(block) {
      // Evita re-inicializar si ya está marcado
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');
  
        function ex_b003_renderPills(block) {
          // Limpiamos cualquier contenido anterior
          block.innerHTML = '';
  
          // Procesamos hasta 4 píldoras
          for (var i = 1; i <= 4; i++) {
            var show = block.getAttribute('data-ex-b003-pill' + i + '-show') === "true";
            if (!show) continue;
  
            var symbol = block.getAttribute('data-ex-b003-pill' + i + '-symbol');
            var text   = block.getAttribute('data-ex-b003-pill' + i + '-text');
            var color  = block.getAttribute('data-ex-b003-pill' + i + '-color');
  
            // Creamos la píldora y le asignamos clases y contenido
            var pill = document.createElement('div');
            pill.classList.add('ex-b003-pill', 'ex-b003-' + color);
            pill.innerHTML = '<span>' + symbol + '</span> <span>' + text + '</span>';
  
            // Agregamos la píldora al contenedor
            block.appendChild(pill);
          }
        }
  
        // Inicializamos el bloque
        ex_b003_renderPills(block);
      }
    });
  });

  // Registro del módulo para el bloque ex_b004 (Reviews de Producto)
EcomverX.registerModule('ex_b004', function(context) {
  // Busca todos los contenedores del bloque en el contexto
  var blocks = context.querySelectorAll('.ex-b004-wrapper');
  blocks.forEach(function(block) {
    // Evita re-inicializar si ya está marcado
    if (!block.hasAttribute('data-ex-initialized')) {
      block.setAttribute('data-ex-initialized', 'true');

      function ex_b004_generateRating(block) {
        var manualDecimal = parseInt(block.getAttribute('data-ex-b004-manual-decimal'), 10);
        var rating = "4." + manualDecimal;
        var ratingEl = block.querySelector('#ex-b004_rating');
        if (ratingEl) {
          ratingEl.textContent = rating + "/5";
        }
      }

      function ex_b004_generateReviews(block) {
        var range = block.getAttribute('data-ex-b004-review-range');
        var min = 100, max = 300;
        if (range === "300-500") {
          min = 300; max = 500;
        } else if (range === "500-700") {
          min = 500; max = 700;
        }
        var reviews = "+" + Math.floor(Math.random() * (max - min) + min);
        var reviewsEl = block.querySelector('#ex-b004_reviews');
        if (reviewsEl) {
          // 'ex_b004.reviews_label' es otra clave que podrías traducir si deseas
          reviewsEl.textContent = reviews;
        }
      }

      function ex_b004_initialize(block) {
        ex_b004_generateRating(block);
        ex_b004_generateReviews(block);
      }

      // Inicializa el bloque
      ex_b004_initialize(block);
    }
  });
});

  // Registro del módulo para el bloque ex_b005 (Cupón para Retargeting)
EcomverX.registerModule('ex_b005', function(context) {
  // Selecciona todos los contenedores del bloque en el contexto
  var blocks = context.querySelectorAll('.ex-b005-alert');

  blocks.forEach(function(block) {
    // Evita re-inicializar si ya está marcado
    if (!block.hasAttribute('data-ex-initialized')) {
      block.setAttribute('data-ex-initialized', 'true');

      // Lógica para mostrar u ocultar el cupón según 'utm_medium=RT' o 'showAlways'
      var showAlways = block.getAttribute('data-ex-b005-show-always') === "true";
      var urlParams = new URLSearchParams(window.location.search);
      var utmMedium = urlParams.get('utm_medium');

      // En modo diseño, se fuerza la visualización
      if (Shopify && Shopify.designMode) {
        block.style.display = "flex";
      } else {
        block.style.display = (showAlways || utmMedium === "RT") ? "flex" : "none";
      }

      // Lógica para copiar el cupón
      var couponText = block.querySelector('#ex-b005_text');
      var copyButton = block.querySelector('#ex-b005_button');

      function copyCoupon() {
        var coupon = couponText.textContent;
        navigator.clipboard.writeText(coupon).then(function() {
          // Cambiamos el texto del botón a "Copiado" (puedes traducirlo)
          copyButton.innerHTML = ex_b005_copiedText;
          setTimeout(function() {
            copyButton.innerHTML = ex_b005_copyText;
          }, 2000);
        }).catch(function(err) {
          console.error("Error al copiar: ", err);
        });
      }

      couponText.addEventListener("click", copyCoupon);
      copyButton.addEventListener("click", copyCoupon);
    }
  });
});

  // Registro del módulo para ex_b008
  EcomverX.registerModule('ex_b008', function(context) {
    var blocks = context.querySelectorAll('.ex-b008-urgency');
    blocks.forEach(function(block) {
      // Si ya se inicializó, no se repite
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');
        // Aplica la opacidad a 1 para el fade-in
        block.style.opacity = "1";
      }
    });
  });

   // Registro del módulo para ex_b009
  EcomverX.registerModule('ex_b009', function(context) {
    var blocks = context.querySelectorAll('.ex-b009-alert');
    blocks.forEach(function(block) {
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');

        var mode = block.getAttribute('data-ex-b009-mode');
        var countEl = block.querySelector('#ex-b009_count');
        if (!countEl) return;

        var purchaseCount;
        if (mode === 'auto') {
          // Número aleatorio entre 550 y 995
          purchaseCount = Math.floor(Math.random() * (995 - 550 + 1)) + 550;
        } else {
          // Modo manual con min y max
          var minVal = parseInt(block.getAttribute('data-ex-b009-manual-min'), 10) || 100;
          var maxVal = parseInt(block.getAttribute('data-ex-b009-manual-max'), 10) || 300;
          if (minVal > maxVal) {
            // En caso de que min sea mayor que max, los intercambiamos o fijamos un valor
            var temp = minVal;
            minVal = maxVal;
            maxVal = temp;
          }
          purchaseCount = Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal;
        }

        countEl.textContent = purchaseCount;
      }
    });
  });

  EcomverX.registerModule('ex_b010', function(context) {
    var blocks = context.querySelectorAll('.ex-b010-wrapper');
    blocks.forEach(function(block) {
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');

        var deliveryDays = parseInt(block.getAttribute('data-ex-b010-delivery-days'), 10) || 3;
        var countdownHours = parseInt(block.getAttribute('data-ex-b010-countdown-hours'), 10) || 2;
        var hideIcon = block.getAttribute('data-ex-b010-hide-icon') === "true";

        // Ocultar icono si corresponde
        if (hideIcon) {
          var iconEl = block.querySelector('.ex-b010-icon');
          if (iconEl) iconEl.style.display = 'none';
        }

        // Cálculo de fecha de entrega
        var today = new Date();
        var deliveryDate = new Date(today);
        deliveryDate.setDate(today.getDate() + deliveryDays);
        var options = { weekday: 'long', day: 'numeric', month: 'long' };
        var formattedDate = deliveryDate.toLocaleDateString('es-ES', options);
        var dateEl = block.querySelector('.ex-b010-date');
        if (dateEl) {
          dateEl.innerText = formattedDate;
        }

        // Manejo del countdown
        var countdownTime = (countdownHours * 3600) + (55 * 60); // Ej: +55 min
        function updateCountdown() {
          var hours = Math.floor(countdownTime / 3600);
          var minutes = Math.floor((countdownTime % 3600) / 60);
          var timerEl = block.querySelector('.ex-b010-timer');
          if (timerEl) {
            timerEl.innerText = hours + " HORA" + (hours !== 1 ? "S" : "") + " " + minutes + " MINUTOS";
          }
          countdownTime--;
          if (countdownTime >= 0) {
            setTimeout(updateCountdown, 1000);
          }
        }
        updateCountdown();
      }
    });
  });

  EcomverX.registerModule('ex_b011', function(context) {
    var blocks = context.querySelectorAll('.ex-b011-wrapper');
    blocks.forEach(function(block) {
      if (!block.hasAttribute('data-ex-initialized')) {
        block.setAttribute('data-ex-initialized', 'true');
        // Actualmente no hay lógica especial que ejecutar.
      }
    });
  });

  EcomverX.registerModule('ex_b012', function(context) {
    var splideEls = context.querySelectorAll('.ex-b012-splide.splide');
    splideEls.forEach(function(splideEl) {
      if (!splideEl.classList.contains('splide-initialized')) {
        new Splide(splideEl, {
          type: 'slide',
          perPage: 1,
          gap: '1rem',
          pagination: true,
          arrows: false
        }).mount();
        splideEl.classList.add('splide-initialized');
      }
    });
  });


  // ================================================================
  // Parte de Secciones
  // ================================================================

// ================================================================
// Módulo para EX‑S005: Comentarios estilo Facebook
// Monta Splide siempre al cargar y genera los valores aleatorios
// ================================================================
EcomverX.registerModule('ex_s005', function(context) {
  // 1) Selecciona cada sección ex-block--s005
  var sections = context.querySelectorAll('.ex-s005');
  sections.forEach(function(sec) {
    if (sec._exs005) return;           // evita doble init
    sec._exs005 = true;

    // 2) Generar aleatorios de hora, reacciones y comentarios
    sec.querySelectorAll('.ex-s005-post').forEach(function(post) {
      var timeEl = post.querySelector('.ex-s005-post__time');
      var rEl    = post.querySelector('.ex-s005-post__reactions-count');
      var cNumEl = post.querySelector('.ex-s005-post__comments-number');

      if (timeEl) {
        var h = Math.floor(Math.random() * 10) + 3;
        timeEl.innerText = h + 'h';
      }
      if (rEl) {
        var r = (Math.random() * 0.8 + 1.1).toFixed(1) + 'k';
        rEl.innerText = r;
      }
      if (cNumEl) {
        var c = Math.floor(Math.random() * (75 - 35 + 1)) + 35;
        cNumEl.innerText = c;
      }
    });

    // 3) Montar Splide sin condiciones
    var splideEl = sec.querySelector('.splide');
    if (splideEl && window.Splide) {
      new Splide(splideEl, {
        type       : 'slide',
        perPage    : 1,
        gap        : '15px',
        padding    : { left: '15px', right: '15px' },
        arrows     : true,
        pagination : true
      }).mount();
    }
  });
});

EcomverX.registerModule('ex_s007', function(context) {
  const sections = context.querySelectorAll('.ex-s007');
  sections.forEach(function(section) {
    if (section._exs007) return;
    section._exs007 = true;

    // Inicializar Splide
    const splideEl = section.querySelector('.splide');
    if (splideEl && typeof Splide !== 'undefined') {
      new Splide(splideEl, {
        type: 'loop',
        perPage: 3,
        gap: '24px',
        pagination: true,
        arrows: true,
        breakpoints: {
          767: {
            perPage: 2,
            arrows: true
          }
        }
      }).mount();
    }

    // Inicializar comportamiento de videos
    const videos = section.querySelectorAll('.ex-s007-video-wrapper video');
    videos.forEach(function(video) {
      // Ocultar barra de progreso solo en WebKit
      video.style.setProperty('--hide-progress', 'true');
    });
  });
});



  // ================================================================
  // 4. Registro de Nuevos Módulos
  // ================================================================
  // Aquí es donde debes registrar otros módulos para nuevos bloques.
  // Por ejemplo, si en el futuro agregas el bloque ex_b002:
  //
  // EcomverX.registerModule('ex_b002', function(context) {
  //   // Busca y procesa los elementos correspondientes a ex_b002
  //   var blocks = context.querySelectorAll('.ex-b002');
  //   blocks.forEach(function(block) {
  //     if (!block.getAttribute('data-ex-initialized')) {
  //       block.setAttribute('data-ex-initialized', 'true');
  //       // Aquí añades la funcionalidad específica para ex_b002.
  //     }
  //   });
  // });
  //
  // Puedes agregar tantos módulos como bloques tengas, siguiendo este patrón.


  // ================================================================
  // Inicialización Global
  // ================================================================
  // Inicializa todos los módulos en el documento (carga normal)
  EcomverX.initModules(document);
  // Activa los eventos de modo diseño (si está en modo diseño)
  EcomverX.initDesignMode();
});